/* src/app/app.component.css */
#app-modal {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-modal-content {
  background-color: #fff;
  width: 500px;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 2rem;
}
/*# sourceMappingURL=app.component.css.map */
